// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.landing {
    position: fixed;
    width: 100%;
    height: 100%;
    background: linear-gradient(107.78deg, #2FC8FA -27.76%, #FFFFFF 109.5%);;
}

.landing .ui.grid {
    height: 100%;
    padding: 1%;
    justify-content: center;
    align-items: center;
}

.landing .ui.grid .column {
    max-width: 388px;
}

.ui.form {
    max-width: 100%;
    margin-top: 40px; 
    font-family: 'Montserrat'!important;
}

.ui.form .title {
    font-size: 18px;
    line-height: 22px;
    font-weight: 400;
    color: #000000;
    text-align: center;
} 

.ui.form .field .ui.input input {
    width: 100%;
    height: 46px;
    background: #FFFFFF;
    border: 1px solid #EEEEEE;
    border-radius: 12px;
    font-style: Montserrat;
} 

.landing ::placeholder{
    color: #333333 !important;
    opacity: 0.3;
}

.landing ::before {
    font-size: 15px;
    color: #333333 !important;
    opacity: 0.3;
    padding-left: 10px;
}

.landing .button {
    width: 100%;
    height: 48px;
    border-radius: 10px;
    font-weight: 600;
    font-size: 22px;
    /* font-family: 'Montserrat'; */
    color: #FFFFFF;
    background: #12C1F9;
    border: none;
}

.landing .message {
    color: #000000 !important;
    font-weight: 500;
    font-size: 14px;
    line-height: 5rem;
    opacity: 0.7;
    display: block;
    text-align: start;
    padding-left: .5rem;
}

`, "",{"version":3,"sources":["webpack://./src/components/Login/Login.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,WAAW;IACX,YAAY;IACZ,uEAAuE;AAC3E;;AAEA;IACI,YAAY;IACZ,WAAW;IACX,uBAAuB;IACvB,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,mCAAmC;AACvC;;AAEA;IACI,eAAe;IACf,iBAAiB;IACjB,gBAAgB;IAChB,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,yBAAyB;IACzB,mBAAmB;IACnB,sBAAsB;AAC1B;;AAEA;IACI,yBAAyB;IACzB,YAAY;AAChB;;AAEA;IACI,eAAe;IACf,yBAAyB;IACzB,YAAY;IACZ,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,gBAAgB;IAChB,eAAe;IACf,+BAA+B;IAC/B,cAAc;IACd,mBAAmB;IACnB,YAAY;AAChB;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,YAAY;IACZ,cAAc;IACd,iBAAiB;IACjB,mBAAmB;AACvB","sourcesContent":[".landing {\n    position: fixed;\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(107.78deg, #2FC8FA -27.76%, #FFFFFF 109.5%);;\n}\n\n.landing .ui.grid {\n    height: 100%;\n    padding: 1%;\n    justify-content: center;\n    align-items: center;\n}\n\n.landing .ui.grid .column {\n    max-width: 388px;\n}\n\n.ui.form {\n    max-width: 100%;\n    margin-top: 40px; \n    font-family: 'Montserrat'!important;\n}\n\n.ui.form .title {\n    font-size: 18px;\n    line-height: 22px;\n    font-weight: 400;\n    color: #000000;\n    text-align: center;\n} \n\n.ui.form .field .ui.input input {\n    width: 100%;\n    height: 46px;\n    background: #FFFFFF;\n    border: 1px solid #EEEEEE;\n    border-radius: 12px;\n    font-style: Montserrat;\n} \n\n.landing ::placeholder{\n    color: #333333 !important;\n    opacity: 0.3;\n}\n\n.landing ::before {\n    font-size: 15px;\n    color: #333333 !important;\n    opacity: 0.3;\n    padding-left: 10px;\n}\n\n.landing .button {\n    width: 100%;\n    height: 48px;\n    border-radius: 10px;\n    font-weight: 600;\n    font-size: 22px;\n    /* font-family: 'Montserrat'; */\n    color: #FFFFFF;\n    background: #12C1F9;\n    border: none;\n}\n\n.landing .message {\n    color: #000000 !important;\n    font-weight: 500;\n    font-size: 14px;\n    line-height: 5rem;\n    opacity: 0.7;\n    display: block;\n    text-align: start;\n    padding-left: .5rem;\n}\n\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
